const LOADED = [];
const FlickitySlider = require('./flickity-slider');
let loading = false;
let bindingEl = '.loadThis';
const Pace = require('pace-js');
const Vue = require('vue');

function load(el) {
    if (LOADED.indexOf(el) === -1 && !loading) {
        return madCall(el, LOADED.length);
    }
}

function madCall(el, order) {
    if (LOADED.indexOf(el) !== -1) {
        return new Promise((resolve, reject) => {
            resolve(el);
        });
    }
    loading = true;
    let call = $(`#${el}`).data('component');
    if ($('#' + el).html().replace(/\s+/, '').length > 0) {
        // On est dans le cas ou on ouvre la page sur un panel precis
        return new Promise((resolve, reject) => {
            Pace.track(() => {
                let provOrder = document.body.dataset.provOrder;
                if (provOrder != undefined) {
                    html = html.replace(/#ORDER#/, provOrder);
                }
                $('#' + el).html($('#' + el).html().replace(/#SHOULD_REVERSE#/, order % 2 ? '' : 'flex-reverse'));
                LOADED.push(el);
                if (document.getElementById(el).classList.contains('component-vue')) {
                    setTimeout(() => {
                        showVue(el);
                    }, 250);
                }
                if (document.getElementById(el).classList.contains('component-carousel')) {
                    FlickitySlider.init('#' + el + ' .main-carousel', el === 'offres' ? 7000 : false);
                }
                loading = false;
                resolve(el);
            });
        });
    }

    return new Promise((resolve, reject) => {
        Pace.track(() => {
            axios.get('/components/' + call).then((response) => {
                let html = response.data,
                provOrder = document.body.dataset.provOrder;
                if (provOrder != undefined) {
                    html = html.replace(/#ORDER#/, provOrder);
                }
                $('#' + el).html(html.replace(/#SHOULD_REVERSE#/, order % 2 ? '' : 'flex-reverse')).css('display', 'none');
                LOADED.push(el);
                if ($('#' + el).find('video').length > 0) {
                    $('#' + el).find('video').get(0).onloadeddata = () => resolve();
                } else {
                    resolve(el);
                }
                $('#' + el).fadeIn('fast', () => {
                    if (document.getElementById(el).classList.contains('component-vue')) {
                        showVue(el);
                    }
                    if (document.getElementById(el).classList.contains('component-carousel')) {
                        FlickitySlider.init('#' + el + ' .main-carousel', el === 'offres' ? 7000 : false);
                    }
                });
            }, () => {
                reject();
            }).then(() => {
                loading = false;
                Pace.restart();
            });
        });
    });
}

function loadAll(els = []) {
    let promises = [];
    let id = LOADED.length === 0 ? 0 : LOADED.length - 1;
    els.forEach((el) => {
        promises.push(madCall(el, id));
        id++;
    });
    return Promise.all(promises);
}

function showContent() {
    $(bindingEl).each(function () {
        let offsetTop = $(this).offset().top;
        if (window.pageYOffset + window.innerHeight > offsetTop) {
            let el = $(this).attr('id');
            load(el);
        }
    });
}

function showVue(el) {
    let elCamelized = camelize(el);
    new Vue({
        name: el,
        el: '#' + el,
        components: { el: elCamelized }
    });
}

function camelize(str) {
    return str.replace(/\W+(.)/g, function(match, chr){
        return chr.toUpperCase();
    });
}

module.exports = {
    bind(el = '.loadThis') {
        bindingEl = el;
        $(document).ready(function () {
            showContent();
        });
        $(document).scroll(function () {
            showContent();
        });
    },
    loadAll(els = []) {
        if (els.length === 0) {
            $(bindingEl).each(function () {
                let el = $(this);
                els.push(el.prop('id'))
            });
        }
        return loadAll(els);
    }
};
